import Hero from '../components/Hero'
import Products from '../components/Products'
import Company from '../components/Company'
import Services from '../components/Services'
import Contact from '../components/Contact'

export default function Home() {
  return (
    <main>
      <Hero />
      <Products />
      <Company />
      <Services />
      <Contact />
    </main>
  )
}
